import {IScrollablePaneStyles, mergeStyleSets, Theme} from '@fluentui/react';

const JUST_RED_COLOR = 'rgb(164, 38, 44)';
export const useMatkonStyles = (theme: Theme) => {
	const classNames = mergeStyleSets({
		arrayWrapper: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		arrayItem: {
			borderRadius: '10px',
			color: theme.palette.neutralSecondary,
			background: theme.palette.neutralLight,
			fontSize: 12,
			padding: '2px 7px',
			marginRight: 5,
			marginBottom: 10,
		},
		form: {
			display: 'flex',
		},
		separatorStyle: {
			borderBottom: '2px dashed gray',
			paddingBottom: '20px',
			paddingTop: '20px',
		},
		application: {
			color: JUST_RED_COLOR,
			paddingRight: '12px',
			paddingLeft: '4px',
		},
		applicationHeader: {
			textAlign: 'center',
			fontSize: '18px',
		},
		oddApplication: {
			background: theme.palette.white,
		},
		evenApplication: {
			background: theme.palette.neutralLight,
		},
		restrictedForPicker: {
			background: theme.palette.white,
		},
	});

	const buttonStyles = {
		root: {
			marginRight: 8,
		},
	};

	const scrollablePaneStyles = {
		root: {
			position: 'relative',
			width: '100%',
			height: '100%',
		},
		contentContainer: {
			overflowX: 'hidden',
		},
	} as Partial<IScrollablePaneStyles>;

	const stackStyles = {
		root: {width: '100%', height: '100%'},
	};

	const stackItemStyles = {
		root: {width: '100%'},
	};

	const tokens = {
		childrenGap: '5px',
	};

	const appHeaderStyles = {
		root: {
			justifyContent: 'end',
		},
	};

	return {
		classNames,
		buttonStyles,
		scrollablePaneStyles,
		stackStyles,
		stackItemStyles,
		appHeaderStyles,
		tokens,
	};
};
